export default "__VITE_ASSET__BkBkHOsO__"